import PopupAdd from "../../../component/PopupAdd/PopupAdd";
import {ApiUrl} from "../../../auth/authMethods";
import React, {useState} from "react";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';

export default function PopupNotify({id}) {

    const [notifyEmail, setNotifyEmail] = useState(true)
    const [notifyWhatsapp, setNotifyWhatsapp] = useState(true)

    const error = (!notifyEmail && !notifyWhatsapp)

    const url = `${ApiUrl}/boletos/notify/${id}`

    const icon = <NotificationsNoneIcon fontSize="large" id="icon-svg"/>

    const buttonText = <span>
        <NotificationsNoneIcon fontSize="medium"/> &nbsp;
        Enviar notificação
    </span>

    const returnData = () => {
        setSent(false)
        return {
            notifyEmail,
            notifyWhatsapp
        }
    }

    const onCloseFunction = () => {
        setSent(false)
        setNotifyEmail(true)
        setNotifyWhatsapp(true)
    }

    const [sent, setSent] = useState(false)

    const inputs = <>
        <Box>
            <FormControl
                required
                error={error}
                component="fieldset"
                sx={{m: 3}}
                variant="standard"
            >
                <FormLabel component="legend">Selecione o(s) método(s) de notificação</FormLabel>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={notifyEmail}
                                onChange={() => setNotifyEmail(prevState => !prevState)}
                                name="Enviar email"
                            />
                        }
                        label="Enviar email"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={notifyWhatsapp}
                                onChange={() => setNotifyWhatsapp(prevState => !prevState)}
                                name="Enviar Whatsapp"
                            />
                        }
                        label="Enviar Whatsapp"
                    />
                </FormGroup>
                {error &&
                    <FormHelperText>Selecione ao menos um método!</FormHelperText>
                }
            </FormControl>

            {sent &&
                <p className='text-success'>Notificação enviada com sucesso!</p>
            }
        </Box>
    </>

    return <PopupAdd
        baseUrl={url} setLoadData={setSent}
        inputs={inputs} title={'Enviar notificação'} icon={icon}
        returnData={returnData}
        buttonClass='dropdown-item'
        button={buttonText} keepOpenAfterSubmit
        onCloseFunction={onCloseFunction}
        disableButton={error}
    />
}